import { Injectable, Injector } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { getIsSiriusEnabled } from '@app/common/sirius-util';
import { AuthSyncGuard } from '@app/auth/auth-sync.guard';
import { UserAuthGuardService } from 'pl-core-services';

@Injectable({ providedIn: 'root' })
export class SiriusOrAuthGuard implements CanActivate {
  constructor(private injector: Injector) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (getIsSiriusEnabled()) {
      // Get AuthSyncGuard instance at runtime
      const authSyncGuard = this.injector.get(AuthSyncGuard);
      // Pass route and state to enable return URL tracking
      return authSyncGuard.canActivate(route, state);
    }
    // Get UserAuthGuardService instance at runtime
    const userAuthGuard = this.injector.get(UserAuthGuardService);
    // UserAuthGuardService's canActivate takes route and state
    return userAuthGuard.canActivate(route, state);
  }
}
